<!-- version 1.0.0 -->
<!-- 2017-9-18 -->
<template>
  <div class="mc-upload-wrap file-upload-warp">
    <div class="upload-btn-wrap" v-fileupload="fileUrl" v-on:upload-change="fileUploadSuccess">
      <el-button size="small" icon="upload2" type="primary">
        <template v-if="(workMode === 'url-name' && fileName) || (workMode === 'url' && fileUrl)">re-upload file</template>
        <template v-else>upload file</template>
      </el-button>
    </div>
    <div class="file-info hf" v-show="(workMode === 'url-name' && fileName) || (workMode === 'url' && fileUrl)">
      <div class="label ftp">upload ready</div>
      <i class="ftp el-icon-document"></i>
      <div class="file-name ftp" :style="{ width: width - 75 + 'px' }" v-if="workMode === 'url-name'">{{fileName}}</div>
      <div class="file-name ftp" :style="{ width: width - 75 + 'px' }" v-if="workMode === 'url'">{{fileUrl}}</div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
// import tools from '@/components/common/tools'

export default {
  name: 'videoUpload',
  props: {
    width: {
      type: Number,
      default: 350
    },
    // 工作模式
    // 'url-name'
    // 'url'
    workMode: {
      type: String,
      default: 'url-name'
    },
    fileName: {
      type: String,
      default: ''
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
    // 上传成功
    fileUploadSuccess(val, data) {
      this.$emit('update:fileUrl', val)
      this.$emit('update:fileName', data.title)
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
.file-upload-warp {
  line-height: 36px;
  .upload-btn-wrap {
    display: inline-block;
  }
  .file-info {
    line-height: 25px;
    color: $c_nc_60;
    font-size: 14px;
    .label {
      color: $c_nc_6;
    }
    i {
      line-height: 25px;
      margin: 0 3px 0 7px;
    }
    .file-name {
      max-width: 300px;
      @include mc_txtJB();
    }
  }
}
</style>



// WEBPACK FOOTER //
// file-upload.vue?5e0401ca